import {VerificationTypes} from "@/models/verification/verification";
import axios from "axios";
import {SecurityActivationServiceDocumentInterface} from "@/views/pages/security/security";
import {ModelErrors} from 'capitalist-shared/src/core/model';
import {WebFormModel} from "capitalist-shared/src/core/model";

export interface VerificationDataInterface extends Record<string, any> {
  verificationData: string
}

export interface TablecodeDataInterface {
  row: string
  column: string
}

export interface VerificationSourceInterface {
  verificationErrors: ModelErrors;

  getVerificationType(): VerificationTypes

  getDataToSign(): Promise<string>

  verify(data: VerificationDataInterface): Promise<Record<any, any>>

  getTablecodeData(): Promise<TablecodeDataInterface>

  getUsername(): string;
}

export class SecurityVerificationSource implements VerificationSourceInterface {

  dataForSign = '';
  documentId = 0
  verificationType: VerificationTypes = VerificationTypes.NONE;
  username = '';
  activation = true;
  service: VerificationTypes = VerificationTypes.GOOGLECODE;
  googleCodeTestForActivation = '';

  verificationErrors: ModelErrors = new ModelErrors();

  setDocument(securityDocument?: SecurityActivationServiceDocumentInterface) {
    if (securityDocument) {
      this.documentId = securityDocument.id;
      this.verificationType = securityDocument.verificationType;
      this.dataForSign = securityDocument.dataForSign;
      this.username = securityDocument.username;
    }
  }

  verify(data: VerificationDataInterface): Promise<Record<any, any>> {
    this.verificationErrors.clear();
    const postData = Object.assign({
      call: 'verify',
      verificationType: this.getVerificationType(),
      service: this.service,
      m: Object.assign({
        activation: this.activation,
        verificationType: this.getVerificationType(),
        documentId: this.documentId,
        id: this.documentId,
        service: this.service,
        pin: this.googleCodeTestForActivation
      }, data)
    }, data);
    return axios.post('/webapi/security/verification', postData).catch((err) => {
      this.verificationErrors.setErrors(WebFormModel.parseAxiosWebapiModelErrors(err).errors);
      throw err;
    });
  }

  getTablecodeData(): Promise<TablecodeDataInterface> {
    return axios.post('/webapi/security/verification', {
      call: 'tableOfCodesData'
    }).then(response => {
      return {
        coords: response.data.model.coords,
        left: response.data.model.left,
      };
    }).catch(error => {
      if (error.response) {
        if ((error.response.status == 422) && (error.response.model))
          return error.response.model.errors.username;
      }
      return error.message;
    });
  }

  getDataToSign(): Promise<string> {
    return Promise.resolve(this.dataForSign);
  }

  getVerificationType(): VerificationTypes {
    return this.verificationType;
  }

  getUsername(): string {
    return this.username;
  }
}
